<template>
  <footer
    :style="footerStyle"
    class="flex flex-grow"
  >
    <!-- Bottom Section of Footer -->
    <div class="footer flex flex-grow text-xs sm:text-sm">
      <div class="footer-bottom-content">
        <p>
          <a
            href="https://neonone.com/privacypolicy/"
            target="_blank"
            data-test="privacy-link"
            >Privacy&nbsp;Statement</a
          >
          |
          <a
            href="https://neonone.com/termsofservice/"
            target="_blank"
            data-test="terms-link"
            >Terms&nbsp;of&nbsp;Service</a
          >
        </p>
      </div>
      <div class="footer-logo">
        <img
          src="https://neonsso-brands.s3.amazonaws.com/clients/59/logo.png"
          alt="Organization Logo"
          :style="{ filter: logoFilter }"
          data-test="footer-logo"
        />
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useDonorStore } from '@/stores/DonorStore.js';
import getContrastYIQ from '@/helpers/getContrastYIQ';

const donorStore = useDonorStore();

const mainColor = donorStore.mainColor;
const fontColor = getContrastYIQ(mainColor);

const getLogoFilter = (color) => {
  if (color === 'white') {
    return 'invert(100%) brightness(400%)';
  } else if (color === 'black') {
    return 'invert(0%) brightness(0%)';
  } else {
    console.error('Unsupported color. Use "white" or "black".');
    return '';
  }
};

const logoFilter = getLogoFilter(fontColor);

const footerStyle = {
  '--main-color': mainColor || 'white',
  '--font-color': fontColor,
};
</script>

<style scoped>
.footer {
  height: 48px;
  background: var(--main-color);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--font-color);
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  justify-content: space-between;
}

.footer-logo img {
  height: 48px;
}

.footer-bottom-content a {
  color: var(--font-color);
  text-decoration: none;
  margin: 0 10px;
}
</style>
